export const defaultValues = {
  approverId: '',
  approverName: '',
  employeeId: '',
  employeeName: '',
  tripErrand: '',
  tripPurpose: '',
  country: '',
  customCountry: '',
  city: '',
  departureDate: '',
  departureTime: '',
  arrivalDate: '',
  arrivalTime: '',
  baggageRequirements: '',
  travelArrangements: '',
  arrangeAccommodation: 'true',
  arrangeFlight: 'true',
  accommodationDetails: '',
  radioExtraDays: 'false',
  addExtraDays: null,
  perDiemOption: 'adrid-dagpeningar',
  ssn: '',
  workProject: '',
  workOrder: '',
  workDepartment: '',
  workLocation: '',
  workProjectId: '',
  workOrderId: '',
  workDepartmentId: '',
  workLocationId: '',
};
